<template>
  <b-nav-item
    v-if="isAvailable"
    :disabled="loading"
    :data-component-name="$options.name"
    class="btn-with-icon"
    data-action="openDigidotPortal"
    href="#"
    @click.prevent="openPortal"
  >
    <b-spinner v-if="loading" small variant="light" class="mr-2" />
    <b-icon v-else icon="upc-scan" class="mr-2" />
    <span class="text">{{ $t('digidot.portalLink') }}</span>
  </b-nav-item>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'DigiDotPortalLink',
  data () {
    return {
      loading: false,
      clientApiId: null
    }
  },
  computed: {
    ...mapState(['config', 'sessionReloaded']),
    isAvailable () {
      return !!this.BasicHelper.getObjectValueByString(this.config, 'plugins.digidot.enabled') && !!this.clientApiId;
    }
  },
  methods: {
    openPortal () {
      if (this.loading) {
        return;
      }
      this.loading = true;
      // Opened before the request, as browsers block popups opened from asynchronous callbacks
      const portalTab = window.open('', '_blank');
      const self = this;
      this.ApiRequest.request(
        'client/single/' + this.clientApiId + '/digidot-portal-link', this.ApiRequest.REQUEST_POST, {},
        function (response) {
          self.loading = false;
          if (response.error || !response.data) {
            if (portalTab) {
              portalTab.close();
            }
            self.ApiRequest.displayErrorDialog(response, self);
            return;
          }
          // Portal link is single-use and short-lived, so it has to be consumed right away
          if (portalTab) {
            portalTab.location.href = response.data.url;
          } else {
            window.location.href = response.data.url;
          }
        }
      );
    }
  },
  watch: {
    sessionReloaded: {
      immediate: true,
      handler () {
        this.clientApiId = this.BasicHelper.getUserClientApiId();
      }
    }
  }
}
</script>
